import { getApiErrorInfo } from '@common/utils/fetcher';

import { MATCHMAKER_ERROR_CODES } from '@services/MatchmakerService';
import { type UserTextRefusal } from '@services/types';

export const MATCHMAKER_NOTE_MAX_LENGTH = 300;

const LINK_PATTERN = /(https?:\/\/|www\.|\bt\.me\/|telegram\.me\/)/i;
const HANDLE_PATTERN = /(^|\s)@[a-z0-9_]{3,}/i;

export const NOTE_REFUSAL_TEXT: Record<UserTextRefusal, string> = {
  link: 'Уберите ссылку',
  handle: 'Уберите @-упоминание',
  too_long: `Не больше ${MATCHMAKER_NOTE_MAX_LENGTH} символов`,
  not_text: 'Записка должна быть текстом',
};

/**
 * A minimal check before sending: only the obvious cases. The server's
 * `invalid_note` reason stays the source of truth.
 */
export const checkNote = (text: string): UserTextRefusal | null => {
  if ([...text].length > MATCHMAKER_NOTE_MAX_LENGTH) return 'too_long';

  if (LINK_PATTERN.test(text)) return 'link';

  if (HANDLE_PATTERN.test(text)) return 'handle';

  return null;
};

const isUserTextRefusal = (value: unknown): value is UserTextRefusal =>
  typeof value === 'string' && value in NOTE_REFUSAL_TEXT;

/** The refused note's reason from a 422 `invalid_note`, or null. */
export const invalidNoteReasonOf = (error: unknown): UserTextRefusal | null => {
  const { code, details } = getApiErrorInfo(error);

  if (code !== MATCHMAKER_ERROR_CODES.invalidNote) return null;

  const reason = details?.reason;

  return isUserTextRefusal(reason) ? reason : 'not_text';
};
